module.exports = __webpack_public_path__ + "img/bari-plus.cb8506da.svg";